import axios from '@/axios'
import setAuthData from './AuthService'

export default { 
  async login(credentials) {
    const response = await axios.post('/login', credentials) 

        localStorage.setItem("token", response.data.token);

        await setAuthData() 
         
    return response.data
  }
}